import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import { ButtonLink } from "@/shared/components/ButtonLink/ButtonLink";
import styles from "./WhatsAppHelp.module.css";

/* Vetor 76x76 do Figma (303:544): o glifo solido em #EBFFF8, sem circulo atras. */
const WHATSAPP_GLYPH =
  "M55.4109 45.5435C54.4654 45.0725 49.8168 42.7964 48.9501 42.4819C48.0835 42.168 47.4532 42.0112 46.8229 42.953C46.1925 43.8947 44.3805 46.0145 43.8289 46.6427C43.2775 47.2705 42.7258 47.3493 41.7803 46.878C40.8348 46.4071 37.7882 45.4136 34.1768 42.2075C31.366 39.7123 29.4683 36.631 28.9169 35.6889C28.3653 34.7469 28.8579 34.2376 29.3313 33.7685C29.7568 33.3468 30.2771 32.6693 30.7497 32.1197C31.2225 31.5704 31.38 31.1777 31.6952 30.5501C32.0104 29.9218 31.8528 29.3725 31.6163 28.9016C31.38 28.4306 29.489 23.7987 28.7011 21.9144C27.9336 20.0797 27.1541 20.3282 26.5737 20.2991C26.0229 20.2719 25.3919 20.2661 24.7617 20.2661C24.1313 20.2661 23.1069 20.5016 22.24 21.4434C21.3736 22.3854 18.9309 24.6622 18.9309 29.2935C18.9309 33.9256 22.3188 38.3999 22.7917 39.0279C23.2646 39.6561 29.4588 49.1606 38.9441 53.2366C41.1998 54.2063 42.961 54.7851 44.3342 55.2188C46.5992 55.9351 48.6603 55.8339 50.2896 55.5916C52.1062 55.3217 55.8837 53.3154 56.6716 51.1175C57.4595 48.919 57.4595 47.035 57.223 46.6427C56.9868 46.25 56.3564 46.0145 55.4109 45.5435ZM38.1589 68.9868L38.1462 68.9868C32.5025 68.9846 26.967 67.4755 22.138 64.6237L20.9894 63.9452L9.08558 67.0529L12.2628 55.5022L11.5152 54.3179C8.36679 49.3342 6.70385 43.5743 6.7063 37.6597C6.71324 20.4015 20.8227 6.36057 38.1714 6.36057C46.5723 6.36355 54.4691 9.62367 60.4076 15.5404C66.3457 21.4568 69.614 29.3212 69.6108 37.6849C69.6037 54.9446 55.4945 68.9868 38.1589 68.9868ZM64.9269 11.0445C57.7826 3.92604 48.2815 0.00406296 38.1586 0C17.301 0 0.32551 16.8933 0.317073 37.6573C0.314352 44.2949 2.05676 50.7735 5.3682 56.4849L0 76L20.06 70.7631C25.5873 73.7633 31.8102 75.3448 38.1435 75.3468L38.1592 75.3468C59.0144 75.3468 75.9914 58.4519 76 37.6875C76.0038 27.6248 72.0713 18.1628 64.9269 11.0445Z";

export function WhatsAppHelp() {
  const { whatsAppHelp } = useMaestriaContent();

  return (
    <section
      id="ajuda"
      className={`maestria-section ${styles.section}`}
      aria-labelledby="help-title"
    >
      <div className={`maestria-container ${styles.inner}`}>
        <div className={styles.box}>
          <svg
            className={styles.icon}
            viewBox="0 0 76 76"
            width={76}
            height={76}
            aria-hidden="true"
            focusable="false"
          >
            <path d={WHATSAPP_GLYPH} fillRule="evenodd" clipRule="evenodd" />
          </svg>
          <h2 id="help-title" className={styles.title}>
            {whatsAppHelp.title}
          </h2>
          <p className={styles.description}>{whatsAppHelp.description}</p>
          <ButtonLink href={whatsAppHelp.cta.href} variant="onGreen">
            {whatsAppHelp.cta.label}
          </ButtonLink>
        </div>
      </div>
    </section>
  );
}
